import { faPenToSquare, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axiosInstance from "../config/axiosInstance";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PaginationBar from "../components/common/PaginationBar";

const DomainList = () => {
  const [domains, setDomains] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filterText, setFilterText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(20);

  useEffect(() => {
    fetchDomains();
  }, []);

  const fetchDomains = async () => {
    try {
      const response = await axiosInstance.get("/domains/list");
      setDomains(response.data?.data);
      setLoading(false);
    } catch (err) {
      setError("Failed to fetch domains");
      setLoading(false);
    }
  };

  const handleDelete = async (domainId) => {
    if (window.confirm("Are you sure you want to delete this domain?")) {
      try {
        await axiosInstance.delete(`/domains/${domainId}`);
        fetchDomains();
      } catch (err) {
        setError("Failed to delete domain");
      }
    }
  };

  // Filter domains based on search text
  const filteredDomains = domains.filter(
    (domain) =>
      domain.domain.toLowerCase().includes(filterText.toLowerCase()) ||
      domain.code.toLowerCase().includes(filterText.toLowerCase())
  );

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredDomains.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredDomains.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="container-fluid">
      <div className="d-sm-flex align-items-center justify-content-between mb-4">
        <h1 className="h3 mb-0 text-gray-800">Domain List</h1>
        <div className="align-items-end">
          <Link
            to="/portal/domains/create"
            className="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm"
          >
            <FontAwesomeIcon icon={faPlus} className="creating-domain mr-2" />
            Create Domain
          </Link>
        </div>
      </div>

      <div className="card shadow mb-4">
        <div className="card-body">
          <div className="row">
            <div className="mb-3 col-3">
              <input
                type="text"
                className="form-control"
                placeholder="Filter by Domain or Code"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
            </div>
          </div>
          <div className="table-responsive">
            <table
              className="table table-bordered"
              width="100%"
              cellSpacing="0"
            >
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Domain</th>
                  <th>Code</th>
                  <th>Service Code</th>
                  <th>Features</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tfoot>
                <tr>
                  <th>ID</th>
                  <th>Domain</th>
                  <th>Code</th>
                  <th>Service Code</th>
                  <th>Features</th>
                  <th>Actions</th>
                </tr>
              </tfoot>
              <tbody>
                {currentItems.map((domain) => (
                  <tr key={domain.id}>
                    <td>{domain.id}</td>
                    <td>{domain.domain}</td>
                    <td>{domain.code}</td>
                    <td>{domain.service_code?.join(", ")}</td>
                    <td>{domain.feature_list?.join(", ")}</td>
                    <td style={{ whiteSpace: "nowrap" }}>
                      <Link
                        to={`/portal/domains/edit/${domain.id}`}
                        className="btn btn-outline-primary btn-sm mr-2"
                      >
                        <FontAwesomeIcon icon={faPenToSquare} /> Edit
                      </Link>
                      <button
                        onClick={() => handleDelete(domain.id)}
                        className="btn btn-danger btn-sm"
                      >
                        <FontAwesomeIcon icon={faTrash} /> Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <PaginationBar page={currentPage} totalPages={totalPages} totalItems={filteredDomains.length} onPageChange={paginate} />
        </div>
      </div>
    </div>
  );
};

export default DomainList;
